import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            最新瓜条
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">刚刚出炉的热乎瓜，趁热吃</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((card, idx) => (
            <div key={idx} className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200/60 transition-all duration-200 flex flex-col">
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[11px] font-medium px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">{card.category}</span>
                  <span className="text-[11px] text-foreground-400">{card.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">{card.summary}</p>
                <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-chat-3-line"></i>
                  <span>{card.comments.toLocaleString()} 条评论</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}